import ControlPointIcon from '@material-ui/icons/ControlPoint';
import React from 'react';
import { __ } from 'artsteps2-common';
import { withDispatch } from '../../enhancers';
import { setUIData } from '../../actions';
import { StyledButton } from '../../styles/GenericStyled';

export const ArtifactUploaderView = ({
  children,
  type = 'image',
  onEditorOpen = () => Promise.resolve(false),
}) => (
  <div className="upload-container">
    <div className="upload-wrapper">
      <div className="ui compact icon buttons uploader">
        <StyledButton type="secondary" onClick={onEditorOpen} style={{ marginBottom: '17px' }}>
          <ControlPointIcon style={{ marginRight: '3px' }} /> {__(`artifact_add_${type}`)}
        </StyledButton>
      </div>
    </div>
    {children}
  </div>
);

const mapDispatch = (dispatch, { type }) => ({
  onEditorOpen: () =>
    dispatch(
      setUIData('artifacts', {
        editingArtifactId: 'new',
        editingArtifactType: type,
      }),
    ),
});

const ArtifactUploader = withDispatch(mapDispatch)(ArtifactUploaderView);

export default ArtifactUploader;
